import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ToasterHelper } from '@shared/helpers';
import { CurrentUserService } from '@core/services';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environments/environment';

@Injectable()
export class GlobalHttpInterceptor implements HttpInterceptor {
    readonly accountRegisterUrl = environment.accountRegisterUrl;

    constructor(
        private messageService: MessageService,
        private currentUserService: CurrentUserService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
        });

        return next.handle(request).pipe(
            catchError(response => {
                if (response?.status === 403) {
                    this.currentUserService.triggerUnauthorizedError(true);
                    return throwError(response);
                }

                if (response?.status === 307) {
                    this.document.location.href = this.accountRegisterUrl;
                    return throwError(response);
                }

                this.currentUserService.triggerUnauthorizedError(false);
                this.messageService.add(ToasterHelper.error(response?.error?.message));
                return throwError(response);
            })
        );
    }
}
